import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Typography } from '@mui/material';

import Stack from '@mui/material/Stack';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { useLocation, Routes, Route, Link as RouterLink } from "react-router-dom"

import logo from './images/logo.png';

import PageHome from './PageHome';
import PageKissat from './PageKissat';
import PageMeista from './PageMeista';
import PageMenu from './PageMenu';
import PageYhteystiedot from './PageYhteystiedot';


const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#7a5d38',
    },
    text: {
      primary: '#000000',
      disabled: '#000000',
    },
    background: {
      default: '#ccb18f',
      paper: '#ccb18f',
    }
  },
  typography: {
    fontFamily: 'CenturyGothic',
    h5: {
      fontSize:25
    },
    h4: {
      fontFamily: 'Freude'
    },
    h3: {
      fontFamily: 'Freude'
    },
    body1: {
      fontSize: '20px'
    }
  }
});


function App() {
  const [mobileDrawerOpen, setMobileDrawerOpen] = React.useState(false);
  const location = useLocation();
  const pages = [
    ['Etusivu', '/', <PageHome/>],
    ['Kissat', '/kissat', <PageKissat/>],
    ['Meistä', '/meista', <PageMeista/>],
    ['Menu', '/menu', <PageMenu/>],
    ['Sijainti ja yhteystiedot', '/yhteystiedot', <PageYhteystiedot/>],
  ];

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Drawer anchor='left' open={mobileDrawerOpen} sx={{ display: { lg: 'none'} }} onClose={() => setMobileDrawerOpen(false)}>
        <Box sx={{ width: 'auto' }} role="presentation" onClick={() => setMobileDrawerOpen(false)} onKeyDown={() => setMobileDrawerOpen(false)}>
          <List>
            {pages.map((page) => (
              <ListItem color='error' key={page[0]} disablePadding sx={{ mb:0 }}>
                <ListItemButton component={ RouterLink } to={page[1]}>
                  <ListItemText  primary={(location.pathname === page[1] ? "> " : "") + page[0]} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      <AppBar position="fixed">
        <Container maxWidth="lg">
          <Box sx={{ width:'100%' }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, display: { lg: 'none'} }}
                onClick={() => setMobileDrawerOpen(true)}
              >
                <MenuIcon />
              </IconButton>
              <Box sx={{margin:1}}>
                <img alt='Kissakahvila Mirri logo' src={logo} height='60px'/>
              </Box>
              <Typography variant="h4" component="div" sx={{ flexGrow: 1, fontFamily:'Freude' }}>Kissakahvila Mirri</Typography>
              <Box sx={{ display: { xs: 'none', lg: 'flex' } }}>
                {pages.map((page) => (
                  <Button
                    key={page[0]}
                    component={ RouterLink }
                    to={page[1]}
                    color={location.pathname === page[1] ? 'primary' : 'secondary'}
                    sx={{ my: 2, mx: 1, display: 'block', fontSize:18}}
                  >
                    {page[0]}
                  </Button>
                ))}
              </Box>
            </Stack>
            </Box>
        </Container>
      </AppBar>
      <Box sx={{ pb:30, minHeight: "100vh"}}>
        <Routes>
          {pages.map((page) => (
            <Route path={page[1]} element= { page[2] } />
          ))}
        </Routes>
      </Box>
    </ThemeProvider>
  );
}
export default App;